module.exports = __webpack_public_path__ + "static/media/CircleClose.07197361.svg";